import { PopoverController } from '@ionic/angular';
import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
    selector: 'profile-popover',
    template: `
    
    <ion-list>
        <ion-item button>Profile overview</ion-item>
        <ion-item button>Settings</ion-item>
    </ion-list>
    <ion-button color="danger" expand="block" (click)="dismiss()">Logout</ion-button>
  `
  })

  export class ProfilePopover {
    constructor(private popoverCtrl: PopoverController, private authenticationService: AuthenticationService) {}

    dismiss() {
      this.popoverCtrl.dismiss();
      this.authenticationService.logout();
    }
  }